import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import AppContext from '@/types/context'

export interface GroupWrapperProps {
  children: Array<PartialWidgetContext>
}

const WrapperArticle = ({ item, context }: { item: GroupWrapperProps; context: AppContext }) => (
  <div className="wrapper-article">
    {item.children.map((widget: PartialWidgetContext, index) => {
      return <Partials key={index} item={widget as any} context={context} />
    })}
  </div>
)

export default WrapperArticle
